import { InjectionToken } from '@angular/core';

import { Message } from './overlay-spinner.service';

export const SPINNER_DATA = new InjectionToken<Message>('SPINNER_DATA');
